import Home from "./components/Home";
import NavBar from "./components/NavBar";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Experience from "./components/Experience";
import SocialLinks from "./components/SocialLinks";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Testimonials from "./components/Testimonials";
function App() {
  return (
    <div>
 <NavBar/>
 <Home/>
 <About/>
 <Portfolio/>
 <Experience/>
 <Testimonials/>
 <Contact/>
 <Footer/>
 <SocialLinks/>
  </div>
  );
}

export default App;
